<template>
    <div>
        <div class="d-flex justify-content-center tab px-0 gap-2" style="overflow: unset">
            <button v-if="template?.trueOrFalse.length > 0" class="tablinks"
                    :class="{active: template?.trueOrFalse.length > 0}"
                    @click="openTap($event , 'trueOrFalse', 'True Or False')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.trueOrFalse[0].title}}</p>
                        <span class="product-details-full">{{this.template.trueOrFalse[0].title}}</span>
                    </div>
            </button>
            <button v-if="template?.multipleChoices.length > 0" class="tablinks"
                    :class="{active: template?.trueOrFalse.length === 0}"
                    @click="openTap($event , 'multipleChoices', 'Multiple Choices')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.multipleChoices[0].title}}</p>
                        <span class="product-details-full">{{this.template.multipleChoices[0].title}}</span>
                    </div>
            </button>
            <button v-if="template?.freeText?.length > 0" class="tablinks"
                    :class="{active:
                    (template?.trueOrFalse.length === 0)
                    &&  (template?.multipleChoices.length === 0)
            }"
                    @click="openTap($event , 'freeText', 'Free Text')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.freeText[0].title}}</p>
                        <span class="product-details-full">{{this.template.freeText[0].title}}</span>
                    </div>
            </button>
            <button v-if="template?.slides.length > 0" class="tablinks"
                    :class="{active:
                    template?.trueOrFalse.length === 0
                    && template?.multipleChoices.length === 0
                    && template?.freeText.length === 0
            }"
                    @click="openTap($event , 'slides', 'Slides')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.slides[0].title}}</p>
                        <span class="product-details-full">{{this.template.slides[0].title}}</span>
                    </div>
            </button>
            <button v-if="template?.rank.length" class="tablinks"
                    :class="{active:
                    template?.slides.length === 0
                    && template?.trueOrFalse.length === 0
                    && template?.multipleChoices.length === 0
                    && template?.freeText.length === 0
            }"
                    @click="openTap($event , 'rank', 'Rank')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.rank[0].title}}</p>
                        <span class="product-details-full">{{this.template.rank[0].title}}</span>
                    </div>
            </button>

            <button v-if="template?.arrange.length > 0" class="tablinks"
                    :class="{active:
                     template?.slides.length === 0
                    && template?.trueOrFalse.length === 0
                    && template?.multipleChoices.length === 0
                    && template?.freeText.length === 0
                    && template?.rank.length === 0
            }"
                    @click="openTap($event , 'arrange', 'Arrange')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{this.template.arrange[0].title}}</p>
                        <span class="product-details-full">{{this.template.arrange[0].title}}</span>
                    </div>
            </button>
        </div>


        <div id="trueOrFalse" ref="trueOrFalse" class="tab-content"
             :class="{'d-block': template?.trueOrFalse.length > 0}">
            <true-or-false-component v-if="this.template?.trueOrFalse.length > 0"
                                     :userAnswers="this.userAnswers"
                                     :template="this.template"/>
        </div>

        <div id="multipleChoices" class="tab-content tabcontent-border-style"
             :class="{'d-block': ((template?.trueOrFalse.length === 0)
             && (this.template?.multipleChoices.length > 0) )}">
            <multiple-choices-component v-if="this.template?.multipleChoices.length > 0"
                                        :userAnswers="this.userAnswers"
                                        :template="this.template"/>
        </div>

        <div id="freeText" class="tab-content tabcontent-border-style"
             :class="{'d-block': ((template?.trueOrFalse.length === 0)
             && (template?.multipleChoices.length === 0)
             && (this.template?.freeText.length > 0))}">
            <free-text-component v-if="this.template?.freeText.length > 0"
                                 :userAnswers="this.userAnswers"
                                 :template="this.template"/>
        </div>

        <div id="slides" class="tab-content tabcontent-border-style"
             :class="{'d-block': ((template?.trueOrFalse.length === 0)
             && (template?.multipleChoices.length === 0) && (this.template?.freeText.length === 0)
             && (this.template?.slides.length > 0))}">
            <slides-component v-if="this.template?.slides?.length > 0"
                              :userAnswers="this.userAnswers"
                              :template="this.template"/>
        </div>

        <div id="rank" class="tab-content tabcontent-border-style"
             :class="{'d-block': ((template?.trueOrFalse.length === 0)
             && (template?.multipleChoices.length === 0)
             && (this.template?.freeText.length === 0)
             && (this.template?.slides.length === 0)
             && (this.template?.rank.length > 0)

             )}">
            <rank-component v-if="this.template?.rank.length > 0"
                            :userAnswers="this.userAnswers"
                            :template="this.template"/>
        </div>

        <div id="arrange" class="tab-content tabcontent-border-style"
             :class="{'d-block': ((template?.trueOrFalse.length === 0)
             && (template?.multipleChoices.length === 0)
             && (this.template?.freeText.length === 0)
             && (this.template?.slides.length === 0)
             && (this.template?.rank.length === 0)
             && (this.template?.arrange.length > 0)

             )}">
            <arrange-component v-if="this.template?.arrange.length > 0"
                               :userAnswers="this.userAnswers"
                               :template="this.template"/>
        </div>
        <!--        <div class="d-flex justify-content-center tab px-0 gap-2">-->
        <!--            <button v-if="template?.trueOrFalse.length > 0" class="tablinks"-->
        <!--                    :class="{active: template?.trueOrFalse.length > 0}"-->
        <!--                    @click="openTap($event , 'trueOrFalse', 'True Or False')">True Or False</button>-->
        <!--            <button v-if="template?.multipleChoices.length > 0" class="tablinks"-->
        <!--                    :class="{active: template?.trueOrFalse.length === 0}"-->
        <!--                    @click="openTap($event , 'multipleChoices', 'Multiple Choices')">Multiple Choices</button>-->
        <!--            <button v-if="template?.freeText.length > 0" class="tablinks"-->
        <!--                    :class="{active: template?.trueOrFalse.length === 0 && template?.multipleChoices.length === 0}"-->
        <!--                    @click="openTap($event , 'freeText', 'Free Text')">Free Text</button>-->
        <!--            <button v-if="template.slides.length > 0" class="tablinks"-->
        <!--                    :class="{active: template?.trueOrFalse.length === 0 && template?.multipleChoices.length === 0 && template?.freeText.length === 0}"-->
        <!--                    @click="openTap($event , 'slides', 'Slides')">Slides</button>-->
        <!--        </div>-->

        <!--        <div id="trueOrFalse" ref="trueOrFalse" class="tabcontent" :class="{'d-block': template?.trueOrFalse.length > 0}">-->
        <!--            <true-or-false-component v-if="this.template?.trueOrFalse.length > 0" :template="this.template" :userAnswers="this.userAnswers"/>-->
        <!--        </div>-->

        <!--        <div id="multipleChoices" class="tabcontent tabcontent-border-style" :class="{'d-block': ((template?.trueOrFalse.length === 0) && (this.template?.multipleChoices.length > 0) )}">-->
        <!--            <multiple-choices-component v-if="this.template?.multipleChoices.length > 0" :template="this.template" :userAnswers="this.userAnswers"/>-->
        <!--        </div>-->

        <!--        <div id="freeText" class="tabcontent tabcontent-border-style" :class="{'d-block': ((template?.trueOrFalse.length === 0) && (template?.multipleChoices.length === 0) && (this.template?.freeText.length > 0))}">-->
        <!--            <free-text-component  v-if="this.template?.freeText.length > 0" :template="this.template" :userAnswers="this.userAnswers"/>-->
        <!--        </div>-->

        <!--        <div id="slides" class="tabcontent tabcontent-border-style" :class="{'d-block': ((template?.trueOrFalse.length === 0) && (template?.multipleChoices.length === 0) && (this.template?.freeText.length === 0) && (this.template.slides?.length > 0))}" >-->
        <!--            <slides-component v-if="this.template.slides?.length > 0" :template="this.template" :userAnswers="this.userAnswers"/>-->
        <!--        </div>-->
    </div>

</template>

<script>

    import TrueOrFalseComponent from "./trueOrFalse";
    import MultipleChoicesComponent from "./multipleChoices";
    import FreeTextComponent from "./freeText";
    import SlidesComponent from "./slides";
    import RankComponent from "./rank";
    import ArrangeComponent from "./arrange";

    import {logger} from "../../../../helpers/logger";

    export default {
        name: 'questions-component',
        components: {
            SlidesComponent,
            FreeTextComponent,
            MultipleChoicesComponent,
            TrueOrFalseComponent,
            RankComponent,
            ArrangeComponent
        },
        data() {
            return {
                steps: {
                    trueOrFalse: false,
                    multipleChoices: false,
                    slides: false,
                    freeText: false,
                    rank: false,
                    arrange: false,
                },
                keys: ['trueOrFalse', 'multipleChoices', 'freeText', 'slides', 'rank', 'arrange']
            }
        },
        async mounted() {
            console.log('as ', this.userAnswers)
            let userArrangeAnswers = [];
            if (this.template?.arrange.length > 0) {

                for(let index=0; index <  this.template?.arrange.length; index++){
                    const ans = this.template.arrange[index]['answers'];
                    this.template.arrange[index]['answers'] =  await this.shuffle(ans);
                    this.userAnswers.answers.forEach((uAns => {
                        if (+uAns.question_id === +this.template?.arrange[index]['id']) {
                            uAns.value = uAns.originalValue;
                            userArrangeAnswers.push(uAns);
                        } else {

                        }
                    }));


                    if (userArrangeAnswers.length > 0) {
                        this.template.arrange[index]['answers'] = userArrangeAnswers;
                        userArrangeAnswers = [];
                    }
                }

                // this.template?.arrange.forEach(  (q) => {
                //     q.answers =   this.shuffle( q.answers)
                //     this.userAnswers.answers.forEach((uAns => {
                //         if (+uAns.question_id === +q.id) {
                //             uAns.value = uAns.originalValue;
                //             userArrangeAnswers.push(uAns);
                //         } else {
                //
                //         }
                //     }));
                //
                //
                //     if (userArrangeAnswers.length > 0) {
                //         q.answers = userArrangeAnswers;
                //         userArrangeAnswers = [];
                //     }
                // })


            }

            console.log('template | arrange => ', this.template?.arrange)
            if (this.template['trueOrFalse'].length > 0) {
                this.steps['trueOrFalse'] = true;
            } else if (this.template['trueOrFalse'].length === 0 && this.template['multipleChoices'].length > 0) {
                this.steps['multipleChoices'] = true;
            } else if (this.template['trueOrFalse'].length === 0 && this.template['multipleChoices'].length === 0 && this.template['freeText'].length > 0) {
                this.steps['freeText'] = true;
            } else if (this.template['trueOrFalse'].length === 0 && this.template['multipleChoices'].length === 0 && this.template['freeText'].length === 0 && this.template['slides'].length > 0) {
                this.steps['slides'] = true;
            } else if (this.template['trueOrFalse'].length === 0 && this.template['multipleChoices'].length === 0 && this.template['freeText'].length === 0 && this.template['slides'].length === 0 && this.template['rank'].length > 0) {
                this.steps['rank'] = true;
            } else if (this.template['trueOrFalse'].length === 0
                && this.template['multipleChoices'].length === 0
                && this.template['freeText'].length === 0
                && this.template['slides'].length === 0
                && this.template['rank'].length === 0
                && this.template['arrange'].length > 0) {
                this.steps['arrange'] = true;
            }

        },
        props: ['userAnswers', 'template'],
        methods: {
            openTap(e, tapName, tapTitle) {
                let i, tabcontent, tablinks;

                if (!this.steps[tapName]) {
                    this.steps[tapName] = true;
                    this.template.viewCounter += 1;
                }

                console.log(tapName, this.template)
                tabcontent = document.getElementsByClassName("tab-content");

                if (tapName !== 'trueOrFalse')
                    e.currentTarget.className += " trueOrFalse";

                for (i = 0; i < tabcontent.length; i++) {
                    // tabcontent[i].style.display = "none";
                    tabcontent[i].className = tabcontent[i].className.replace(" d-block", "");
                    tabcontent[i].className = tabcontent[i].className.replace(" d-none", "");
                    tabcontent[i].className += " d-none";
                }
                tablinks = document.getElementsByClassName("tablinks");
                for (i = 0; i < tablinks.length; i++) {
                    tablinks[i].className = tablinks[i].className.replace(" active", "");
                }
                // document.getElementById(tapName).style.display = "block";
                e.currentTarget.className += " active";
                document.getElementById(tapName).className = document.getElementById(tapName).className.replace("d-none", "d-block");
            },
            shuffle(data) {
                logger(["before shuffle => ", data]);
                for (let i = data.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [data[i], data[j]] = [data[j], data[i]];
                }
                logger(["after shuffle => ", data]);

                return data;
            }
        }
    }
</script>

<style >
    .product-details{
        white-space: nowrap;
        width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'Lato', sans-serif;
    }
    .product-details:hover + .product-details-full {
        position: absolute;
        top: -40px;
        background-color: #002634;
        display: flex;
        padding: 5px 10px;
        font-family: 'Lato', sans-serif;
        border-radius: 5px;
    }

    .product-details-full {
        display: none;
    }

    .tablinks {
        max-width: 200px;
        position: relative;
        font-weight: 500;
        font-size: 15px;
        background-color: var(--tabLinkBackgroundColorTemplate);
        border-radius: 12px 12px 0 0;
    }

    .tab-content {
        padding: 15px;
        display: none;
        overflow-y: auto;
        height: 55vh;
        border-radius: 20px;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
    }

    .ans-q-container {
        border-bottom: 1px solid var(--border-color-data-table);
        margin-bottom: 10px;
        padding-bottom: 10px;
    }

    .ans-q-container:last-child {
        border-bottom: none;
    }

    .q-content{
        padding-left: 15px;
    }
    .ans-content{
        padding-left: 15px;
    }
</style>